<!-- ContabilidadNavigationTabs.vue -->
<template>
  <div>
    <v-row>
      <v-col>
        <h1 class="text-h5 font-weight-bold">Contabilidad</h1>
        <p class="text-subtitle-1">Gestión de la contabilidad de la sucursal</p>
      </v-col>
    </v-row>
    <v-divider class="mb-2"></v-divider>
    <router-view :planDeCuentas="planDeCuentas" />
  </div>
</template>


<script>
import LayoutBasic from "@/layouts/LayoutBasic.vue";

import { mapActions, mapState } from "vuex";

export default {
  name: "ContabilidadHome",
  components: {
    LayoutBasic,
  },
  data() {
    return {
      /*  Mantiene la pestaña actual en función de la ruta */
      current: null,
    };
  },

  computed: {
    ...mapState("contabilidad", ["planDeCuentas"]),
  },
  methods: {
    ...mapActions("contabilidad", ["fetchPlanDeCuentas"]),
    async fetchCuentas() {
      try {
        await this.fetchPlanDeCuentas({ empresaUuid: null, isActive: true });
      } catch (error) {
        console.error("Error al obtener el plan de cuentas:", error);
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "info",
          text: "Error al obtener el plan de cuentas",
          icon: "mdi-information",
          timeout: 3000,
        });
      }
    },
  },

  created() {
    this.fetchCuentas();
  },
};
</script>

<style lang="scss" scoped></style>
